module.exports = __webpack_public_path__ + "static/media/campground.daf9c529.svg";